export default "__VITE_ASSET__DqutX$$z__"